import { defineComponent as _defineComponent } from 'vue'
import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';

export default /*#__PURE__*/_defineComponent({
  __name: 'TakeCourseEmpty',
  setup(__props) {

  
return { __sfc: true,EmptyStateEntry }
}

})